import React from 'react';
import {defaultErrorHandler} from '../../../context/context';
import customFormsV2Client from '../../../infrastructure/acerill/custom-forms-v2-client';
import CenteredSpinner from '../../../libs/react-components-admin/spinners/centered-spinner';
import ActionButton from '../../../libs/react-components-admin/buttons/action-button';

export default class ZapierSample extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      forms: null,
      selectedFormId: null,
    };
  }
  componentDidMount() {
    customFormsV2Client
      .findAllForms()
      .then(forms => this.setState({forms: forms, selectedFormId: forms[0].id}))
      .catch(defaultErrorHandler);
  }

  sendSampleFormSubmission() {
    return customFormsV2Client
      .sendZapierTriggerTestEvent('form-submitted', { formId: this.state.selectedFormId });
  }

  render() {
    if (!this.state.forms) {
      return <CenteredSpinner/>;
    }
    return <div className="row ms-md-3 mt-3">
      <label htmlFor="form" className="col-auto col-form-label">Form:</label>
      <div className="col-5">
        <select id="form" name="form"
                className="form-select"
                value={this.state.selectedFormId}
                onChange={e => this.setState({ selectedFormId: e.target.value })}>
          {this.state.forms.map(form => {
            return <option key={form.id} value={form.id}>{form.name}</option>
          })}
        </select>
      </div>
      <div className="col-5 col-md-3 d-grid">
        <ActionButton className="btn-primary px-3"
                      action={() => this.sendSampleFormSubmission()}
                      errorHandler={defaultErrorHandler}
                      disabled={!this.state.selectedFormId}>
          Submit to Zapier
        </ActionButton>
      </div>
    </div>
  }

}
